export default __webpack_public_path__ + "static/media/Frame 1.c2218a68.png";